import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Zones } from "@/components/Zones";
import { Gallery } from "@/components/Gallery";
import { Faq } from "@/components/Faq";
import { TikTok } from "@/components/TikTok";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CITY_SLUGS, CityPage } from "@/pages/CityPage";
import { BRAND_SLUGS, COMBO_REPAIRS, REPAIR_SLUGS, RepairPage } from "@/pages/RepairPage";
import { Reservation } from "@/pages/Reservation";

function HomePage() {
  const scrollTo = (id) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "auto" });
  };

  return (
    <div className="relative min-h-screen bg-[#E8F1FC] text-zinc-900 antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Marquee />
        <Services />
        <Process />
        <Zones />
        <Gallery />
        <Faq />
        <TikTok />
      </main>
      <Footer onNavigate={scrollTo} />
      <WhatsAppButton />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/reservation" element={<Reservation />} />
        {CITY_SLUGS.map((slug) => (
          <Route
            key={slug}
            path={`/reparation-telephone-${slug}`}
            element={<CityPage citySlug={slug} />}
          />
        ))}
        {REPAIR_SLUGS.map((slug) => (
          <Route
            key={slug}
            path={`/reparation-${slug}-lyon`}
            element={<RepairPage repairSlug={slug} />}
          />
        ))}
        {REPAIR_SLUGS.flatMap((slug) =>
          BRAND_SLUGS.map((brand) => (
            <Route
              key={`${slug}-${brand}`}
              path={`/reparation-${slug}-${brand}-lyon`}
              element={<RepairPage repairSlug={slug} brandSlug={brand} />}
            />
          ))
        )}
        {COMBO_REPAIRS.flatMap((slug) =>
          CITY_SLUGS.map((city) => (
            <Route
              key={`${slug}-${city}`}
              path={`/reparation-${slug}-${city}`}
              element={<RepairPage repairSlug={slug} citySlug={city} />}
            />
          ))
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
